import {useState} from 'react';

import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';

import FormInput from '../common/FormInput';

import {getReportNames} from '../../helpers/reports';

const getFields = () => ([
  {
    name: 'report_name',
    label: 'Report Name',
    type: 'select',
    options: getReportNames().map(r => ({value: r.key, label: r.name})),
    required: true,
    fullWidth: true,
    minWidth: '250px',
    grid: {
      xs: 12,
      md: 6,
    },
  },
  {
    name: 'provider_id',
    label: 'Provider',
    type: 'selectProvider',
    required: false,
    fullWidth: true,
    maxWidth: '300px',
    reportNames: ['weekly_provider_actuation_summary'],
    grid: {
      xs: 12,
      md: 6,
    },
  },
  {
    name: 'facility__id',
    label: 'Facility',
    type: 'selectLocation',
    required: false,
    fullWidth: true,
    maxWidth: '300px',
    reportNames: ['weekly_provider_actuation_summary'],
    grid: {
      xs: 12,
      md: 6,
    },
  },
]);

const ReportForm = ({onSubmit}) => {
  const [formValues, setFormValues] = useState({report_name: ''});
  const fields = getFields() || [];
  return (
    <Grid container spacing={1}>
      {fields.map(f => 
        <Grid item key={f.name} xs={f.grid?.xs || 12} md={f.grid?.md || 12}>
          <FormInput 
            key={f.name} 
            {...f} 
            onChange={(e, val) => setFormValues({
              ...formValues,
              [f.name]: val || e?.target?.value,
            })}
          />
        </Grid>
      )}
      <Grid item xs={12} alignItems='center'>
        <Button
          variant='contained'
          onClick={e => onSubmit(e, formValues)}
        >
          Create Report
        </Button>
      </Grid>
    </Grid>
  );
};

export default ReportForm;